import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loader = ({ flexDirection = "row", fontSize = 54, width = "100%" }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 54 }} spin />;

  return (
    <div
      style={{
        width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection,
        height: "100vh",
      }}
      aria-busy="true"
      aria-live="polite"
    >
      <Spin indicator={antIcon} />
    </div>
  );
};

export default Loader;
